
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { APANextBatchInfo, BaseResult, ICreateEFTCriteria, IDocument, IEFTEmailCriteria, IPaymentPrintBatch, IPrintChecksCriteria, IRenumberChecksCriteria, IValidationResult } from "@tylertech/tyler-api-types";

/**
 * PaymentPrintBatchService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class PaymentPrintBatchService {
    constructor(private readonly $apiService: ApiService) { }
    
    AccountSummaryReport(voucherID: string): Promise<IDocument> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/AccountSummaryReport", voucherID);
    }
    ArchiveChecks(clearDate: Date): Promise<void> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/ArchiveChecks", clearDate);
    }
    CreateEFT(criteria: ICreateEFTCriteria): Promise<IDocument> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/CreateEFT", criteria);
    }
    GenerateCheckRegister(batchId: string): Promise<IDocument> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/GenerateCheckRegister", batchId);
    }
    GenerateCoverPage(batchId: string): Promise<IDocument> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/GenerateCoverPage", batchId);
    }
    GenerateJournalEntryReport(batchId: string): Promise<IDocument> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/GenerateJournalEntryReport", batchId);
    }
    GenerateNoticeReport(criteria: IPrintChecksCriteria): Promise<IDocument> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/GenerateNoticeReport", criteria);
    }
    Get(id: string): Promise<IPaymentPrintBatch> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/Get", id);
    }
    GetDefaultEftFileName(bankCodeId: string): Promise<string> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/GetDefaultEftFileName", bankCodeId);
    }
    GetNextAPABatchInfo(voucherNumber: string): Promise<APANextBatchInfo> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/GetNextAPABatchInfo", voucherNumber);
    }
    GetStartingCheckNumber(criteria: IPrintChecksCriteria): Promise<string> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/GetStartingCheckNumber", criteria);
    }
    GetUserEmails(): Promise<string[]> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/GetUserEmails");
    }
    PreparePrintChecks(criteria: IPrintChecksCriteria): Promise<IPrintChecksCriteria> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/PreparePrintChecks", criteria);
    }
    PrintChecks(criteria: IPrintChecksCriteria): Promise<IDocument> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/PrintChecks", criteria);
    }
    PrintDetailReport(voucherID: string): Promise<IDocument> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/PrintDetailReport", voucherID);
    }
    PrintNonBatchChecks(checksToPrint: string[]): Promise<IDocument[]> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/PrintNonBatchChecks", checksToPrint);
    }
    RenumberChecks(criteria: IRenumberChecksCriteria): Promise<IPaymentPrintBatch> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/RenumberChecks", criteria);
    }
    Save(printBatch: IPaymentPrintBatch): Promise<IPaymentPrintBatch> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/Save", printBatch);
    }
    SendEFTEmailWithAttachments(emailCriteria: IEFTEmailCriteria): Promise<IDocument[]> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/SendEFTEmailWithAttachments", emailCriteria);
    }
    SendPaymentsToAPAutomation(voucherNumber: string): Promise<BaseResult> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/SendPaymentsToAPAutomation", voucherNumber);
    }
    SubmitBatch(batchId: string): Promise<boolean> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/SubmitBatch", batchId);
    }
    Validate(printBatch: IPaymentPrintBatch): Promise<IValidationResult<IPaymentPrintBatch>> {
        return this.$apiService.sendAuth("IPaymentPrintBatchService/Validate", printBatch);
    }
}
